import copy from 'copy-to-clipboard';
import { useCallback } from 'react';
import { GovIcon } from '@gov-design-system-ce/react';
import { useMessageEvents } from '@gov-nx/core/events';
import { LocalizeNameSpaceTypes, useLocale } from '@gov-nx/core/service';
import type { WebCopyButtonProps } from '@gov-nx/ui/types';
import { Button } from './Button';

export const CopyButton = ({
	label,
	value,
	onCopy,
	size = 's',
	color = 'primary',
	type = 'base',
	children,
}: WebCopyButtonProps) => {
	const { toastMessageSuccess } = useMessageEvents();
	const { t } = useLocale(LocalizeNameSpaceTypes.Global);

	const copyValue = useCallback(() => {
		const valueToCopy = value == null ? '' : value.toString();
		const result = copy(valueToCopy);
		onCopy?.(valueToCopy, result);
		toastMessageSuccess(t('akce.zkopirovano'));
	}, [onCopy, t, toastMessageSuccess, value]);

	return (
		<Button
			color={color}
			aria-label={label}
			size={size}
			onClick={copyValue}
			type={type}>
			{children ? (
				children
			) : (
				<GovIcon
					name="copy"
					type="components"
					slot="icon-end"
				/>
			)}
		</Button>
	);
};
